import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_VIDEO] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.video = payload
  },
  [types.SET_VIDEOS] (state, payload) {
    state.videos = payload.data
    state.pagination = payload.meta.pagination
  }
}
